export default __webpack_public_path__ + "static/media/cat7-5.aa7e0c6b.jpg";